<template>
  <div class="sectionWorld" :class="'world-' + worldPic" id="world">
    <div class="header">
      <p class="big">{{ $t(websiteConfig.world.mainTitle) }}</p>
      <p class="small">{{ $t(websiteConfig.world.subTitle) }}</p>
    </div>
    <div class="type-pagination" @click="clickBtnUpload"></div>
    <swiper
      class="outside-container"
      :noSwiping="true"
      :pagination="outsideSwiperConfig"
      :loop="true"
      :threshold="10"
      @slideChange="changeBackground"
      ref="worldRef"
    >
      <swiper-slide v-for="(world, index) in worldText" :key="index">
        <div
          class="text-wrap"
          :class="{ active: !isSupported || targetIsVisible }"
        >
          <p
            class="text"
            v-for="(text, textIndex) in world"
            :key="textIndex"
            :class="'text-' + textIndex"
            >{{ $t(text) }}</p
          >
        </div>
      </swiper-slide>
      <div class="world-pagination"></div>
    </swiper>
  </div>
</template>

<script setup lang="ts">
import worldHook from '@/hooks/worldHook';
import { clickBtnUpload } from '@/utils/pointUtils';
import { Swiper, SwiperSlide } from 'swiper/vue';
import SwiperCore, { Pagination } from 'swiper';
const {
  worldText,
  outsideSwiperConfig,
  worldRef,
  targetIsVisible,
  isSupported,
  changeBackground,
  worldPic,
  websiteConfig,
} = worldHook();
SwiperCore.use([Pagination]);
</script>
